<template>
    <!-- eslint-disable -->
    <decorator-icon v-bind="attrs">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M4.276 8.66668L8.47133 12.862L7.52867 13.8047L1.724 8.00001L7.52867 2.19534L8.47133 3.13801L4.276 7.33334H14V8.66668H4.276Z"
              fill="inherit"/>
    </decorator-icon>
</template>

<script>
import DecoratorIcon from '../decorator/dp-icon-decorator'
import MixinIcon from '../mixin/dp-icon-mixin'

export default {
  name: 'dp-arrow-left-icon',
  mixins: [MixinIcon],
  components: {
    DecoratorIcon
  },
  data() {
    return {
      viewBox: '0 0 16 16'
    }
  }
}
</script>
